export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    LOGIN_WITH_TOKEN: '/login/:token/:refreshToken?',
    BEGIN_REGISTRATION: '/begin-registration',
    REGISTRATION: '/registration',
    REGISTER_FINISH: '/register/finish',
    REGISTER_CONFIRM: '/register/confirm',
    RECOVERY_PASSWORD: '/recovery-password',
    RECOVERY_PASSWORD_CALLME: '/recovery-password-callme',
} as const;
